export default "__VITE_ASSET__BFhiPcf7__"